import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GuidedTourService } from '../../services/guided-tour.service';

import { PermissionBaseComponent } from '../../../../core/abstracts/permission-base.component';
import { PermissionService } from '../../../../core/services/common/permission.service';
import { MenuService } from '../../../../core/components/header/services/menu.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-guided-tour',
    imports: [
        CommonModule
    ],
    templateUrl: './guided-tour.component.html',
    styleUrl: './guided-tour.component.scss'
})
export class GuidedTourComponent extends PermissionBaseComponent implements OnInit {

  public showTooltip = signal<boolean>(false);
  public isDefaultPosition = signal<boolean>(false);

  constructor(
    protected override permissionService: PermissionService,
    protected guidedTourService: GuidedTourService,
    protected menuService: MenuService,
    private router: Router
  ) {
    super(permissionService);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.checkDefaultPosition();

    this.router.events.subscribe(() => {
      this.checkDefaultPosition();
    });

    if (this.isFreemium) {
      this.showTooltip.set(true);

      setTimeout(() => {
        this.showTooltip.update(v => !v);
      }, 10000);
    }
  }

  private checkDefaultPosition(): void {
    this.isDefaultPosition.set(this.router.url === '/home');
  }
}